<template>
  <div class="sidebar"
       :style="sidebarStyle"
       :data-color="backgroundColor"
       :data-image="backgroundImage"
       :data-active-color="activeColor">

    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <el-tooltip class="item" effect="dark" content="'SERVEL'" placement="top-start">
        <div class="logo">
          <a href="/" class="simple-text logo-mini d-flex align-items-center">
            <div class="logo-img">
              <img width="150px" class="img-fluid" :src="logo" alt="logo">
            </div>
          </a>
          <a href="/" class="simple-text logo-normal d-flex align-items-end">
            SERVEL
          </a>

        </div>
      </el-tooltip>
      <slot>

      </slot>
      <ul class="nav" role="menu" data-cy="menu-parent">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>

      </ul>
    </div>
  </div>
</template>
<script>
import {Tooltip} from "element-ui";

export default {
  name: 'sidebar',
  components: {
    [Tooltip.name]: Tooltip,
  },
  props: {
    title: {
      type: String,
      default: 'Servel'
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: (value) => {
        let acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black']
        return acceptedValues.indexOf(value) !== -1
      }
    },
    backgroundImage: {
      type: String,
      default: '/static/img/sidebar-5.jpg'
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: (value) => {
        let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
        return acceptedValues.indexOf(value) !== -1
      }
    },
    logo: {
      type: String,
      default: '/img/logo1.jpg'
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    }
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`
      }
    }
  },
  methods: {
    async initScrollBarAsync() {
      await import('perfect-scrollbar/dist/css/perfect-scrollbar.css')
      const PerfectScroll = await import('perfect-scrollbar')
      PerfectScroll.initialize(this.$refs.sidebarScrollArea)
    }
  },
  mounted() {
    this.initScrollBarAsync()
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false
    }
  }
}

</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}

.sidebar .logo a.logo-mini {
  width: 30px !important;
  margin-right: 3px !important;
}

.sidebar .logo-img {
  background: none !important;
  margin-right: 0px !important;
  line-height: 0px !important;
}

</style>
